// Build GitHub-flavored markdown of the board and copy it to the clipboard.

import type { Quadrant } from "../generated/Quadrant";
import { tasksInQuadrant } from "../state";

const QUADRANT_HEADINGS: Array<{ q: Quadrant; heading: string }> = [
  { q: "q1", heading: "Important and urgent" },
  { q: "q2", heading: "Important and not urgent" },
  { q: "q3", heading: "Not important and urgent" },
  { q: "q4", heading: "Not important and not urgent" },
];

export function buildMarkdown(): string {
  const sections: string[] = [];
  for (const { q, heading } of QUADRANT_HEADINGS) {
    const lines = [`## ${heading}`, ""];
    for (const [, task] of tasksInQuadrant(q)) {
      const mark = task.completedAt ? "x" : " ";
      lines.push(`* [${mark}] ${task.label}`);
    }
    sections.push(lines.join("\n"));
  }
  return sections.join("\n\n") + "\n";
}

export async function copyMarkdownToClipboard(): Promise<boolean> {
  const md = buildMarkdown();
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(md);
      return true;
    }
  } catch {
    // fall through to legacy path
  }
  return legacyCopy(md);
}

function legacyCopy(text: string): boolean {
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.setAttribute("readonly", "");
  ta.style.position = "fixed";
  ta.style.top = "-1000px";
  document.body.append(ta);
  ta.select();
  let ok = false;
  try {
    ok = document.execCommand("copy");
  } catch {
    ok = false;
  }
  ta.remove();
  return ok;
}
